import SetUserThemeResponse from 'owa-service/lib/contract/SetUserThemeResponse';
import setUserThemeRequest from 'owa-service/lib/factory/setUserThemeRequest';
import setUserThemeOperation from 'owa-service/lib/operation/setUserThemeOperation';

export default function setUserTheme(themeId: string): Promise<SetUserThemeResponse> {
    return setUserThemeOperation({
        request: setUserThemeRequest({
            ThemeId: themeId,
        }),
    });
}
